export const EASE = [0.16, 1, 0.3, 1];
export const TIMING = { feedback: 0.22, state: 0.36, scene: 0.78 };
